import { Button, Col, Modal, Row } from 'react-bootstrap';

const SECTION_FIELDS = [
  { title: 'Queixa Principal E Historia', key: 'QUEIXAS' },
  { title: 'Medicacoes em Uso', key: 'MEDICAMENTOS' },
  { title: 'Habitos', key: 'HABITOS' },
  { title: 'Antecedentes Pessoais/Familiares', key: 'ANTECEDENTES_PESSOAIS' },
  { title: 'Exames Complementares Previo', key: 'EXAMES_COMPLEMENTARES' },
  { title: 'Exames Fisicos', key: 'EXAME_FISICO' },
  { title: 'ECG', key: 'ISDA' },
  { title: 'Hipotese Diagnostica', key: 'HIPOTESE_DIAGNOSTICA' },
  { title: 'Conduta', key: 'CONDUTA' },
  { title: 'Observacoes', key: 'OBS' },
  { title: 'CID1', key: 'CID' },
  { title: 'CID2', key: 'CID2' },
  { title: 'CID3', key: 'CID3' },
];

export default function ModalProntuario({ show, onHide, prontuario }) {
  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Anamnese / Prontuario</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto' }}>
        <Row className="mb-3">
          <Col md={6}>
            <strong>Paciente:</strong> {prontuario?.NOMEPAC || '-'}
          </Col>
          <Col md={6}>
            <strong>CPF:</strong> {prontuario?.CPFPAC || '-'}
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={6}>
            <strong>Data de Nascimento:</strong> {prontuario?.dataNasc || '-'}
          </Col>
          <Col md={6}>
            <strong>Data do Atendimento:</strong> {prontuario?.dataFormatada || '-'}
          </Col>
        </Row>
        <Row className="mb-4">
          <Col md={6}>
            <strong>Medico Responsavel:</strong> {prontuario?.NOMEMED || '-'}
          </Col>
          <Col md={6}>
            <strong>CRM:</strong> {prontuario?.CRMMED || '-'}
          </Col>
        </Row>

        {SECTION_FIELDS.map((section) => (
          <div key={section.key} className="mb-3">
            <div style={{ fontWeight: 700, color: '#0d6efd', marginBottom: 4 }}>
              {section.title}
            </div>
            <div
              style={{
                border: '1px solid #dee2e6',
                borderRadius: 6,
                padding: '8px 10px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {prontuario?.[section.key] || '-'}
            </div>
          </div>
        ))}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
